import * as React from "react";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import { 
    Box, AppBar as MuiAppBar, Toolbar, CssBaseline, Typography, 
    IconButton, Avatar, Tooltip, AppBarProps as MuiAppBarProps 
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/reducers/index";
import { sessionEnd } from "../redux/actions";
import useWindowDimensions from "../tools/useWindowDimensions";
import DrawerHeader from "./DrawerHeader";
import Navbar from "./Navbar";
import logo from "../img/logo/Kairos-removebg-preview.webp";
import { frFR } from '@mui/x-data-grid';
import { frFR as coreFrFR } from '@mui/material/locale';

// Thème orange dédié au Prévisionnel
const forecastTheme = createTheme(
    {
        palette: {
            primary: {
                main: '#ff9800',
                light: '#eeeeee',
                contrastText: '#434241',
            },
            secondary: {
                main: '#ffffff',
            },
        }
    },
    frFR,
    coreFrFR
);

// AppBar en Blanc Pur avec ombre subtile
const StyledAppBar = styled(MuiAppBar)<MuiAppBarProps>(({ theme }) => ({
    backgroundColor: "#ffffff",
    color: "#1e293b", // Texte sombre pour le contraste
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 0 rgba(0, 0, 0, 0.06)", // Ombre très légère
    borderBottom: "1px solid #e2e8f0",
    zIndex: theme.zIndex.drawer + 1,
}));

export default function LayoutForecast() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { width } = useWindowDimensions();
    const username = useSelector((state: RootState) => state.user.username);
    
    const [open, setOpen] = React.useState(false);
    const mobile = width ? width < 900 : false;

    return (
        <ThemeProvider theme={forecastTheme}>
        <Box sx={{ display: "flex", bgcolor: "#f8fafc", minHeight: "100vh" }}>
            <CssBaseline />
            
            {/* APP BAR UNIQUE REUTILISÉE */}
            <Navbar showMenuButton={false} />

            <Box component="main" sx={{ flexGrow: 1, width: "100%" }}>
                <DrawerHeader /> 
                <Box sx={{ p: 0 }}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
        </ThemeProvider>
    );
}